<template>
  <div class="flex flex-wrap -mx-10">
    <ArticlePreview
      v-for="article in articles"
      :key="article.id"
      :article="article"
      class="w-full px-10 pb-10 sm:w-1/2 md:w-1/3"
    />
  </div>
</template>

<script>
import ArticlePreview from '@/components/article/ArticlePreview';

export default defineNuxtComponent({
  components: {
    ArticlePreview,
  },
  props: {
    articles: {
      type: Array,
      required: true,
    },
  },
});
</script>
